<template>
  <div class="column pt-0">
    <h2 class="is-size-5 has-text-weight-semibold mb-4">Список CMS</h2>
    <div class="columns is-multiline is-variable is-2 mb-4">
      <div class="column is-2">
        <b-field label="Компания">
          <b-select v-model="filters.company_id" expanded placeholder="Все">
            <option :value="null">Все</option>
            <option v-for="company in companies" :key="company.id" :value="company.id">
              {{ company.name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field label="Филиал">
          <b-select v-model="filters.branch_id" expanded placeholder="Все" :disabled="!filters.company_id">
            <option :value="null">Все</option>
            <option v-for="branch in branches" :key="branch.id" :value="branch.id">
              {{ branch.name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field label="Завод">
          <b-select v-model="filters.factory_id" expanded placeholder="Все" :disabled="!filters.branch_id">
            <option :value="null">Все</option>
            <option v-for="factory in factories" :key="factory.id" :value="factory.id">
              {{ factory.name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-2">
        <b-field label="Поиск">
          <b-input v-model.trim="filters.search" placeholder="Поиск" />
        </b-field>
      </div>
      <div class="column is-4 is-flex is-align-items-flex-end" style="gap: 0.75rem">
        <b-button type="is-info" @click="applyFilters">Применить</b-button>
        <b-button v-if="hasActiveFilters" type="is-light" @click="resetFilters">Сброс</b-button>
      </div>
    </div>
    <BaseTable
      :data="agents"
      :columns="columns"
      :loading="isLoading"
      :total="total"
      :per-page="perPage"
      :current-page="currentPage"
      @change="fetchAgents"
      @rowClick="onRowClick"
    />
  </div>
</template>


<script>
import BaseTable from "@/components/Base/Table";

export default {
  components: { BaseTable },
  data() {
    return {
      agents: [],
      total: 0,
      isLoading: true,
      currentPage: 1,
      perPage: 15,
      filters: {
        factory_id: null,
        branch_id: null,
        company_id: null,
        search: "",
      },
      companies: [],
      branches: [],
      factories: [],
      columns: [
        {
          field: "id",
          label: "ID",
          width: "40",
          numeric: true,
        },
        {
          field: "factory.branch.company.name",
          label: "Компания",
          centered: true,
        },
        {
          field: "device_name",
          label: "CMS",
        },
        {
          field: "ip",
          label: "IP",
        },
        {
          field: "ip_local",
          label: "Локальный IP",
        },
        {
          field: "status",
          label: "Статус",
        },
        {
          field: "actions",
          label: "",
        },
      ],
    };
  },
  computed: {
    hasActiveFilters() {
      return !!(
        this.filters.company_id ||
        this.filters.branch_id ||
        this.filters.factory_id ||
        (this.filters.search && this.filters.search.trim())
      )
    },
  },
  watch: {
    "filters.company_id"(newValue) {
      this.filters.branch_id = null
      this.filters.factory_id = null
      this.branches = []
      this.factories = []
      if (newValue) this.fetchCompanyBranches(newValue)
    },
    "filters.branch_id"(newValue) {
      this.filters.factory_id = null
      this.factories = []
      if (newValue) this.fetchBranchFactories(newValue)
    },
  },
  mounted() {
    this.fetchCompanies();
    this.fetchAgents();
    this.fetchBranchesPaginate();
  },
  methods: {
    applyFilters() {
      this.fetchAgents(1)
    },
    resetFilters() {
      this.filters.company_id = null
      this.filters.branch_id = null
      this.filters.factory_id = null
      this.filters.search = ""
      this.branches = []
      this.factories = []
      this.fetchAgents(1)
    },
    async fetchCompanies() {
      try {
        const { data } = await this.$axios.get(`admin/companies`)
        this.companies = data?.data || []
      } catch (e) {
        console.log(e)
      }
    },
    async fetchCompanyBranches(companyId) {
      try {
        const { data } = await this.$axios.get(`admin/companies/${companyId}/branches`)
        this.branches = data?.data || []
      } catch (e) {
        console.log(e)
      }
    },
    async fetchBranchFactories(branchId) {
      try {
        const { data } = await this.$axios.get(`admin/branches/${branchId}/factories`)
        this.factories = data?.data || []
      } catch (e) {
        console.log(e)
      }
    },
    async fetchBranchesPaginate() {
      try {
        const { data } = await this.$axios.get(`admin/branches/paginate/0/100`)
        console.log(data)
      } catch (e) {
        console.log(e)
      }
    },
    async fetchAgents(page) {
      this.currentPage = page || 1
      this.isLoading = true;
      try {
        const offset = (this.currentPage - 1) * this.perPage
        const params = new URLSearchParams()
        if (this.filters.factory_id) params.append("factory_id", this.filters.factory_id)
        if (this.filters.branch_id) params.append("branch_id", this.filters.branch_id)
        if (this.filters.company_id) params.append("company_id", this.filters.company_id)
        if (this.filters.search) params.append("search", this.filters.search)
        const query = params.toString()
        const url = query
          ? `admin/agents/paginate/${offset}/${this.perPage}?${query}`
          : `admin/agents/paginate/${offset}/${this.perPage}`
        const { data } = await this.$axios.get(url)
        this.agents = data?.data || [];
        this.total = data?.count;
      } catch (e) {
        throw new Error(e)
      }
      this.isLoading = false;
    },
    onRowClick(item) {
      this.$router.push(`/cms-editor/${item.id}`);
    },
  },
};
</script>
